import axios from '@/utils'

// 活动登录
export function promote_login(data) {
    return axios({
        method: 'post',
        url: '/promote/login',
        data
    })
}

// 领取和预约
export function promote_checkin(data) {
    return axios({
        method: 'post',
        url: '/promote/checkin',
        data
    })
}

// 核销人员登录
export function login_sevenLogin (data) {
    return axios({
        method: 'post',
        url: '/login/sevenLogin',
        data
    })
}

//邀请人状态信息
export function status_checkin(data){
	return axios({
	    method: 'post',
	    url: '/promote/status/checkin',
	    data
	})
}